module.exports = "/assets/data/23404dab3e9acee710a82e7233e86f0f-CF35.data.json";